import "./sprinkles.css.ts.vanilla.css-mistica.js";
import { createSprinkles as a } from "@vanilla-extract/sprinkles/createRuntimeSprinkles";
var l = a({
    conditions: void 0,
    styles: {
        isolation: {
            values: {
                isolate: {
                    defaultClass: "_1y2v1nfhd"
                }
            }
        },
        position: {
            values: {
                relative: {
                    defaultClass: "_1y2v1nfhe"
                },
                absolute: {
                    defaultClass: "_1y2v1nfhf"
                },
                fixed: {
                    defaultClass: "_1y2v1nfhg"
                },
                static: {
                    defaultClass: "_1y2v1nfhh"
                },
                sticky: {
                    defaultClass: "_1y2v1nfhi"
                }
            }
        },
        display: {
            values: {
                none: {
                    defaultClass: "_1y2v1nfhj"
                },
                flex: {
                    defaultClass: "_1y2v1nfhk"
                },
                "inline-flex": {
                    defaultClass: "_1y2v1nfhl"
                },
                block: {
                    defaultClass: "_1y2v1nfhm"
                },
                inline: {
                    defaultClass: "_1y2v1nfhn"
                },
                "inline-block": {
                    defaultClass: "_1y2v1nfho"
                }
            }
        },
        flexDirection: {
            values: {
                row: {
                    defaultClass: "_1y2v1nfhp"
                },
                column: {
                    defaultClass: "_1y2v1nfhq"
                }
            }
        },
        justifyContent: {
            values: {
                stretch: {
                    defaultClass: "_1y2v1nfhr"
                },
                "flex-start": {
                    defaultClass: "_1y2v1nfhs"
                },
                center: {
                    defaultClass: "_1y2v1nfht"
                },
                "flex-end": {
                    defaultClass: "_1y2v1nfhu"
                },
                "space-around": {
                    defaultClass: "_1y2v1nfhv"
                },
                "space-between": {
                    defaultClass: "_1y2v1nfhw"
                }
            }
        },
        alignItems: {
            values: {
                stretch: {
                    defaultClass: "_1y2v1nfhx"
                },
                "flex-start": {
                    defaultClass: "_1y2v1nfhy"
                },
                center: {
                    defaultClass: "_1y2v1nfhz"
                },
                "flex-end": {
                    defaultClass: "_1y2v1nfi0"
                },
                baseline: {
                    defaultClass: "_1y2v1nfi1"
                }
            }
        },
        flexShrink: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfi2"
                },
                1: {
                    defaultClass: "_1y2v1nfi3"
                }
            }
        },
        flexGrow: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfi4"
                },
                1: {
                    defaultClass: "_1y2v1nfi5"
                }
            }
        },
        flex: {
            values: {
                1: {
                    defaultClass: "_1y2v1nfi6"
                }
            }
        },
        width: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfi9"
                },
                2: {
                    defaultClass: "_1y2v1nfia"
                },
                4: {
                    defaultClass: "_1y2v1nfib"
                },
                8: {
                    defaultClass: "_1y2v1nfic"
                },
                12: {
                    defaultClass: "_1y2v1nfid"
                },
                16: {
                    defaultClass: "_1y2v1nfie"
                },
                20: {
                    defaultClass: "_1y2v1nfif"
                },
                24: {
                    defaultClass: "_1y2v1nfig"
                },
                32: {
                    defaultClass: "_1y2v1nfih"
                },
                40: {
                    defaultClass: "_1y2v1nfii"
                },
                48: {
                    defaultClass: "_1y2v1nfij"
                },
                56: {
                    defaultClass: "_1y2v1nfik"
                },
                64: {
                    defaultClass: "_1y2v1nfil"
                },
                72: {
                    defaultClass: "_1y2v1nfim"
                },
                80: {
                    defaultClass: "_1y2v1nfin"
                },
                "100%": {
                    defaultClass: "_1y2v1nfi7"
                },
                auto: {
                    defaultClass: "_1y2v1nfi8"
                }
            }
        },
        height: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfip"
                },
                2: {
                    defaultClass: "_1y2v1nfiq"
                },
                4: {
                    defaultClass: "_1y2v1nfir"
                },
                8: {
                    defaultClass: "_1y2v1nfis"
                },
                12: {
                    defaultClass: "_1y2v1nfit"
                },
                16: {
                    defaultClass: "_1y2v1nfiu"
                },
                20: {
                    defaultClass: "_1y2v1nfiv"
                },
                24: {
                    defaultClass: "_1y2v1nfiw"
                },
                32: {
                    defaultClass: "_1y2v1nfix"
                },
                40: {
                    defaultClass: "_1y2v1nfiy"
                },
                48: {
                    defaultClass: "_1y2v1nfiz"
                },
                56: {
                    defaultClass: "_1y2v1nfj0"
                },
                64: {
                    defaultClass: "_1y2v1nfj1"
                },
                72: {
                    defaultClass: "_1y2v1nfj2"
                },
                80: {
                    defaultClass: "_1y2v1nfj3"
                },
                "100%": {
                    defaultClass: "_1y2v1nfio"
                }
            }
        },
        minWidth: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfj5"
                },
                2: {
                    defaultClass: "_1y2v1nfj6"
                },
                4: {
                    defaultClass: "_1y2v1nfj7"
                },
                8: {
                    defaultClass: "_1y2v1nfj8"
                },
                12: {
                    defaultClass: "_1y2v1nfj9"
                },
                16: {
                    defaultClass: "_1y2v1nfja"
                },
                20: {
                    defaultClass: "_1y2v1nfjb"
                },
                24: {
                    defaultClass: "_1y2v1nfjc"
                },
                32: {
                    defaultClass: "_1y2v1nfjd"
                },
                40: {
                    defaultClass: "_1y2v1nfje"
                },
                48: {
                    defaultClass: "_1y2v1nfjf"
                },
                56: {
                    defaultClass: "_1y2v1nfjg"
                },
                64: {
                    defaultClass: "_1y2v1nfjh"
                },
                72: {
                    defaultClass: "_1y2v1nfji"
                },
                80: {
                    defaultClass: "_1y2v1nfjj"
                },
                "100%": {
                    defaultClass: "_1y2v1nfj4"
                }
            }
        },
        minHeight: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfjk"
                },
                2: {
                    defaultClass: "_1y2v1nfjl"
                },
                4: {
                    defaultClass: "_1y2v1nfjm"
                },
                8: {
                    defaultClass: "_1y2v1nfjn"
                },
                12: {
                    defaultClass: "_1y2v1nfjo"
                },
                16: {
                    defaultClass: "_1y2v1nfjp"
                },
                20: {
                    defaultClass: "_1y2v1nfjq"
                },
                24: {
                    defaultClass: "_1y2v1nfjr"
                },
                32: {
                    defaultClass: "_1y2v1nfjs"
                },
                40: {
                    defaultClass: "_1y2v1nfjt"
                },
                48: {
                    defaultClass: "_1y2v1nfju"
                },
                56: {
                    defaultClass: "_1y2v1nfjv"
                },
                64: {
                    defaultClass: "_1y2v1nfjw"
                },
                72: {
                    defaultClass: "_1y2v1nfjx"
                },
                80: {
                    defaultClass: "_1y2v1nfjy"
                }
            }
        },
        maxWidth: {
            values: {
                "100%": {
                    defaultClass: "_1y2v1nfjz"
                }
            }
        },
        maxHeight: {
            values: {
                "100%": {
                    defaultClass: "_1y2v1nfk0"
                }
            }
        },
        border: {
            values: {
                regular: {
                    defaultClass: "_1y2v1nfk1"
                },
                none: {
                    defaultClass: "_1y2v1nfk2"
                }
            }
        },
        borderRadius: {
            values: {
                2: {
                    defaultClass: "_1y2v1nfk4"
                },
                4: {
                    defaultClass: "_1y2v1nfk5"
                },
                8: {
                    defaultClass: "_1y2v1nfk6"
                },
                16: {
                    defaultClass: "_1y2v1nfk7"
                },
                20: {
                    defaultClass: "_1y2v1nfk8"
                },
                "50%": {
                    defaultClass: "_1y2v1nfk3"
                },
                "var(--_1vqcj1i78)": {
                    defaultClass: "_1y2v1nfk9"
                },
                "var(--_1vqcj1i79)": {
                    defaultClass: "_1y2v1nfka"
                },
                "var(--_1vqcj1i7a)": {
                    defaultClass: "_1y2v1nfkb"
                },
                "var(--_1vqcj1i7b)": {
                    defaultClass: "_1y2v1nfkc"
                },
                "var(--_1vqcj1i7c)": {
                    defaultClass: "_1y2v1nfkd"
                },
                "var(--_1vqcj1i7d)": {
                    defaultClass: "_1y2v1nfke"
                },
                "var(--_1vqcj1i7e)": {
                    defaultClass: "_1y2v1nfkf"
                },
                "var(--_1vqcj1i7f)": {
                    defaultClass: "_1y2v1nfkg"
                },
                "var(--_1vqcj1i7g)": {
                    defaultClass: "_1y2v1nfkh"
                },
                "var(--_1vqcj1i7h)": {
                    defaultClass: "_1y2v1nfki"
                },
                "var(--_1vqcj1i7i)": {
                    defaultClass: "_1y2v1nfkj"
                }
            }
        },
        cursor: {
            values: {
                pointer: {
                    defaultClass: "_1y2v1nfkk"
                }
            }
        },
        overflow: {
            values: {
                hidden: {
                    defaultClass: "_1y2v1nfkl"
                },
                visible: {
                    defaultClass: "_1y2v1nfkm"
                },
                auto: {
                    defaultClass: "_1y2v1nfkn"
                }
            }
        },
        overflowY: {
            values: {
                hidden: {
                    defaultClass: "_1y2v1nfko"
                },
                visible: {
                    defaultClass: "_1y2v1nfkp"
                },
                auto: {
                    defaultClass: "_1y2v1nfkq"
                }
            }
        },
        top: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfkr"
                },
                2: {
                    defaultClass: "_1y2v1nfks"
                },
                4: {
                    defaultClass: "_1y2v1nfkt"
                },
                8: {
                    defaultClass: "_1y2v1nfku"
                },
                12: {
                    defaultClass: "_1y2v1nfkv"
                },
                16: {
                    defaultClass: "_1y2v1nfkw"
                },
                20: {
                    defaultClass: "_1y2v1nfkx"
                },
                24: {
                    defaultClass: "_1y2v1nfky"
                },
                32: {
                    defaultClass: "_1y2v1nfkz"
                },
                40: {
                    defaultClass: "_1y2v1nfl0"
                },
                48: {
                    defaultClass: "_1y2v1nfl1"
                },
                56: {
                    defaultClass: "_1y2v1nfl2"
                },
                64: {
                    defaultClass: "_1y2v1nfl3"
                },
                72: {
                    defaultClass: "_1y2v1nfl4"
                },
                80: {
                    defaultClass: "_1y2v1nfl5"
                }
            }
        },
        left: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfl6"
                },
                2: {
                    defaultClass: "_1y2v1nfl7"
                },
                4: {
                    defaultClass: "_1y2v1nfl8"
                },
                8: {
                    defaultClass: "_1y2v1nfl9"
                },
                12: {
                    defaultClass: "_1y2v1nfla"
                },
                16: {
                    defaultClass: "_1y2v1nflb"
                },
                20: {
                    defaultClass: "_1y2v1nflc"
                },
                24: {
                    defaultClass: "_1y2v1nfld"
                },
                32: {
                    defaultClass: "_1y2v1nfle"
                },
                40: {
                    defaultClass: "_1y2v1nflf"
                },
                48: {
                    defaultClass: "_1y2v1nflg"
                },
                56: {
                    defaultClass: "_1y2v1nflh"
                },
                64: {
                    defaultClass: "_1y2v1nfli"
                },
                72: {
                    defaultClass: "_1y2v1nflj"
                },
                80: {
                    defaultClass: "_1y2v1nflk"
                }
            }
        },
        right: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfll"
                },
                2: {
                    defaultClass: "_1y2v1nflm"
                },
                4: {
                    defaultClass: "_1y2v1nfln"
                },
                8: {
                    defaultClass: "_1y2v1nflo"
                },
                12: {
                    defaultClass: "_1y2v1nflp"
                },
                16: {
                    defaultClass: "_1y2v1nflq"
                },
                20: {
                    defaultClass: "_1y2v1nflr"
                },
                24: {
                    defaultClass: "_1y2v1nfls"
                },
                32: {
                    defaultClass: "_1y2v1nflt"
                },
                40: {
                    defaultClass: "_1y2v1nflu"
                },
                48: {
                    defaultClass: "_1y2v1nflv"
                },
                56: {
                    defaultClass: "_1y2v1nflw"
                },
                64: {
                    defaultClass: "_1y2v1nflx"
                },
                72: {
                    defaultClass: "_1y2v1nfly"
                },
                80: {
                    defaultClass: "_1y2v1nflz"
                }
            }
        },
        bottom: {
            values: {
                0: {
                    defaultClass: "_1y2v1nfm0"
                },
                2: {
                    defaultClass: "_1y2v1nfm1"
                },
                4: {
                    defaultClass: "_1y2v1nfm2"
                },
                8: {
                    defaultClass: "_1y2v1nfm3"
                },
                12: {
                    defaultClass: "_1y2v1nfm4"
                },
                16: {
                    defaultClass: "_1y2v1nfm5"
                },
                20: {
                    defaultClass: "_1y2v1nfm6"
                },
                24: {
                    defaultClass: "_1y2v1nfm7"
                },
                32: {
                    defaultClass: "_1y2v1nfm8"
                },
                40: {
                    defaultClass: "_1y2v1nfm9"
                },
                48: {
                    defaultClass: "_1y2v1nfma"
                },
                56: {
                    defaultClass: "_1y2v1nfmb"
                },
                64: {
                    defaultClass: "_1y2v1nfmc"
                },
                72: {
                    defaultClass: "_1y2v1nfmd"
                },
                80: {
                    defaultClass: "_1y2v1nfme"
                }
            }
        },
        objectFit: {
            values: {
                cover: {
                    defaultClass: "_1y2v1nfmf"
                }
            }
        }
    }
}, {
    conditions: {
        defaultCondition: "mobile",
        conditionNames: [
            "mobile",
            "tablet",
            "desktop"
        ],
        responsiveArray: void 0
    },
    styles: {
        padding: {
            mappings: [
                "paddingTop",
                "paddingBottom",
                "paddingLeft",
                "paddingRight"
            ]
        },
        paddingX: {
            mappings: [
                "paddingLeft",
                "paddingRight"
            ]
        },
        paddingY: {
            mappings: [
                "paddingTop",
                "paddingBottom"
            ]
        },
        paddingTop: {
            values: {
                0: {
                    conditions: {
                        mobile: "_1y2v1nf7d",
                        tablet: "_1y2v1nf7e",
                        desktop: "_1y2v1nf7f"
                    },
                    defaultClass: "_1y2v1nf7d"
                },
                2: {
                    conditions: {
                        mobile: "_1y2v1nf7g",
                        tablet: "_1y2v1nf7h",
                        desktop: "_1y2v1nf7i"
                    },
                    defaultClass: "_1y2v1nf7g"
                },
                4: {
                    conditions: {
                        mobile: "_1y2v1nf7j",
                        tablet: "_1y2v1nf7k",
                        desktop: "_1y2v1nf7l"
                    },
                    defaultClass: "_1y2v1nf7j"
                },
                8: {
                    conditions: {
                        mobile: "_1y2v1nf7m",
                        tablet: "_1y2v1nf7n",
                        desktop: "_1y2v1nf7o"
                    },
                    defaultClass: "_1y2v1nf7m"
                },
                12: {
                    conditions: {
                        mobile: "_1y2v1nf7p",
                        tablet: "_1y2v1nf7q",
                        desktop: "_1y2v1nf7r"
                    },
                    defaultClass: "_1y2v1nf7p"
                },
                16: {
                    conditions: {
                        mobile: "_1y2v1nf7s",
                        tablet: "_1y2v1nf7t",
                        desktop: "_1y2v1nf7u"
                    },
                    defaultClass: "_1y2v1nf7s"
                },
                20: {
                    conditions: {
                        mobile: "_1y2v1nf7v",
                        tablet: "_1y2v1nf7w",
                        desktop: "_1y2v1nf7x"
                    },
                    defaultClass: "_1y2v1nf7v"
                },
                24: {
                    conditions: {
                        mobile: "_1y2v1nf7y",
                        tablet: "_1y2v1nf7z",
                        desktop: "_1y2v1nf80"
                    },
                    defaultClass: "_1y2v1nf7y"
                },
                32: {
                    conditions: {
                        mobile: "_1y2v1nf81",
                        tablet: "_1y2v1nf82",
                        desktop: "_1y2v1nf83"
                    },
                    defaultClass: "_1y2v1nf81"
                },
                40: {
                    conditions: {
                        mobile: "_1y2v1nf84",
                        tablet: "_1y2v1nf85",
                        desktop: "_1y2v1nf86"
                    },
                    defaultClass: "_1y2v1nf84"
                },
                48: {
                    conditions: {
                        mobile: "_1y2v1nf87",
                        tablet: "_1y2v1nf88",
                        desktop: "_1y2v1nf89"
                    },
                    defaultClass: "_1y2v1nf87"
                },
                56: {
                    conditions: {
                        mobile: "_1y2v1nf8a",
                        tablet: "_1y2v1nf8b",
                        desktop: "_1y2v1nf8c"
                    },
                    defaultClass: "_1y2v1nf8a"
                },
                64: {
                    conditions: {
                        mobile: "_1y2v1nf8d",
                        tablet: "_1y2v1nf8e",
                        desktop: "_1y2v1nf8f"
                    },
                    defaultClass: "_1y2v1nf8d"
                },
                72: {
                    conditions: {
                        mobile: "_1y2v1nf8g",
                        tablet: "_1y2v1nf8h",
                        desktop: "_1y2v1nf8i"
                    },
                    defaultClass: "_1y2v1nf8g"
                },
                80: {
                    conditions: {
                        mobile: "_1y2v1nf8j",
                        tablet: "_1y2v1nf8k",
                        desktop: "_1y2v1nf8l"
                    },
                    defaultClass: "_1y2v1nf8j"
                }
            }
        },
        paddingBottom: {
            values: {
                0: {
                    conditions: {
                        mobile: "_1y2v1nf8m",
                        tablet: "_1y2v1nf8n",
                        desktop: "_1y2v1nf8o"
                    },
                    defaultClass: "_1y2v1nf8m"
                },
                2: {
                    conditions: {
                        mobile: "_1y2v1nf8p",
                        tablet: "_1y2v1nf8q",
                        desktop: "_1y2v1nf8r"
                    },
                    defaultClass: "_1y2v1nf8p"
                },
                4: {
                    conditions: {
                        mobile: "_1y2v1nf8s",
                        tablet: "_1y2v1nf8t",
                        desktop: "_1y2v1nf8u"
                    },
                    defaultClass: "_1y2v1nf8s"
                },
                8: {
                    conditions: {
                        mobile: "_1y2v1nf8v",
                        tablet: "_1y2v1nf8w",
                        desktop: "_1y2v1nf8x"
                    },
                    defaultClass: "_1y2v1nf8v"
                },
                12: {
                    conditions: {
                        mobile: "_1y2v1nf8y",
                        tablet: "_1y2v1nf8z",
                        desktop: "_1y2v1nf90"
                    },
                    defaultClass: "_1y2v1nf8y"
                },
                16: {
                    conditions: {
                        mobile: "_1y2v1nf91",
                        tablet: "_1y2v1nf92",
                        desktop: "_1y2v1nf93"
                    },
                    defaultClass: "_1y2v1nf91"
                },
                20: {
                    conditions: {
                        mobile: "_1y2v1nf94",
                        tablet: "_1y2v1nf95",
                        desktop: "_1y2v1nf96"
                    },
                    defaultClass: "_1y2v1nf94"
                },
                24: {
                    conditions: {
                        mobile: "_1y2v1nf97",
                        tablet: "_1y2v1nf98",
                        desktop: "_1y2v1nf99"
                    },
                    defaultClass: "_1y2v1nf97"
                },
                32: {
                    conditions: {
                        mobile: "_1y2v1nf9a",
                        tablet: "_1y2v1nf9b",
                        desktop: "_1y2v1nf9c"
                    },
                    defaultClass: "_1y2v1nf9a"
                },
                40: {
                    conditions: {
                        mobile: "_1y2v1nf9d",
                        tablet: "_1y2v1nf9e",
                        desktop: "_1y2v1nf9f"
                    },
                    defaultClass: "_1y2v1nf9d"
                },
                48: {
                    conditions: {
                        mobile: "_1y2v1nf9g",
                        tablet: "_1y2v1nf9h",
                        desktop: "_1y2v1nf9i"
                    },
                    defaultClass: "_1y2v1nf9g"
                },
                56: {
                    conditions: {
                        mobile: "_1y2v1nf9j",
                        tablet: "_1y2v1nf9k",
                        desktop: "_1y2v1nf9l"
                    },
                    defaultClass: "_1y2v1nf9j"
                },
                64: {
                    conditions: {
                        mobile: "_1y2v1nf9m",
                        tablet: "_1y2v1nf9n",
                        desktop: "_1y2v1nf9o"
                    },
                    defaultClass: "_1y2v1nf9m"
                },
                72: {
                    conditions: {
                        mobile: "_1y2v1nf9p",
                        tablet: "_1y2v1nf9q",
                        desktop: "_1y2v1nf9r"
                    },
                    defaultClass: "_1y2v1nf9p"
                },
                80: {
                    conditions: {
                        mobile: "_1y2v1nf9s",
                        tablet: "_1y2v1nf9t",
                        desktop: "_1y2v1nf9u"
                    },
                    defaultClass: "_1y2v1nf9s"
                }
            }
        },
        paddingLeft: {
            values: {
                0: {
                    conditions: {
                        mobile: "_1y2v1nf9v",
                        tablet: "_1y2v1nf9w",
                        desktop: "_1y2v1nf9x"
                    },
                    defaultClass: "_1y2v1nf9v"
                },
                2: {
                    conditions: {
                        mobile: "_1y2v1nf9y",
                        tablet: "_1y2v1nf9z",
                        desktop: "_1y2v1nfa0"
                    },
                    defaultClass: "_1y2v1nf9y"
                },
                4: {
                    conditions: {
                        mobile: "_1y2v1nfa1",
                        tablet: "_1y2v1nfa2",
                        desktop: "_1y2v1nfa3"
                    },
                    defaultClass: "_1y2v1nfa1"
                },
                8: {
                    conditions: {
                        mobile: "_1y2v1nfa4",
                        tablet: "_1y2v1nfa5",
                        desktop: "_1y2v1nfa6"
                    },
                    defaultClass: "_1y2v1nfa4"
                },
                12: {
                    conditions: {
                        mobile: "_1y2v1nfa7",
                        tablet: "_1y2v1nfa8",
                        desktop: "_1y2v1nfa9"
                    },
                    defaultClass: "_1y2v1nfa7"
                },
                16: {
                    conditions: {
                        mobile: "_1y2v1nfaa",
                        tablet: "_1y2v1nfab",
                        desktop: "_1y2v1nfac"
                    },
                    defaultClass: "_1y2v1nfaa"
                },
                20: {
                    conditions: {
                        mobile: "_1y2v1nfad",
                        tablet: "_1y2v1nfae",
                        desktop: "_1y2v1nfaf"
                    },
                    defaultClass: "_1y2v1nfad"
                },
                24: {
                    conditions: {
                        mobile: "_1y2v1nfag",
                        tablet: "_1y2v1nfah",
                        desktop: "_1y2v1nfai"
                    },
                    defaultClass: "_1y2v1nfag"
                },
                32: {
                    conditions: {
                        mobile: "_1y2v1nfaj",
                        tablet: "_1y2v1nfak",
                        desktop: "_1y2v1nfal"
                    },
                    defaultClass: "_1y2v1nfaj"
                },
                40: {
                    conditions: {
                        mobile: "_1y2v1nfam",
                        tablet: "_1y2v1nfan",
                        desktop: "_1y2v1nfao"
                    },
                    defaultClass: "_1y2v1nfam"
                },
                48: {
                    conditions: {
                        mobile: "_1y2v1nfap",
                        tablet: "_1y2v1nfaq",
                        desktop: "_1y2v1nfar"
                    },
                    defaultClass: "_1y2v1nfap"
                },
                56: {
                    conditions: {
                        mobile: "_1y2v1nfas",
                        tablet: "_1y2v1nfat",
                        desktop: "_1y2v1nfau"
                    },
                    defaultClass: "_1y2v1nfas"
                },
                64: {
                    conditions: {
                        mobile: "_1y2v1nfav",
                        tablet: "_1y2v1nfaw",
                        desktop: "_1y2v1nfax"
                    },
                    defaultClass: "_1y2v1nfav"
                },
                72: {
                    conditions: {
                        mobile: "_1y2v1nfay",
                        tablet: "_1y2v1nfaz",
                        desktop: "_1y2v1nfb0"
                    },
                    defaultClass: "_1y2v1nfay"
                },
                80: {
                    conditions: {
                        mobile: "_1y2v1nfb1",
                        tablet: "_1y2v1nfb2",
                        desktop: "_1y2v1nfb3"
                    },
                    defaultClass: "_1y2v1nfb1"
                }
            }
        },
        paddingRight: {
            values: {
                0: {
                    conditions: {
                        mobile: "_1y2v1nfb4",
                        tablet: "_1y2v1nfb5",
                        desktop: "_1y2v1nfb6"
                    },
                    defaultClass: "_1y2v1nfb4"
                },
                2: {
                    conditions: {
                        mobile: "_1y2v1nfb7",
                        tablet: "_1y2v1nfb8",
                        desktop: "_1y2v1nfb9"
                    },
                    defaultClass: "_1y2v1nfb7"
                },
                4: {
                    conditions: {
                        mobile: "_1y2v1nfba",
                        tablet: "_1y2v1nfbb",
                        desktop: "_1y2v1nfbc"
                    },
                    defaultClass: "_1y2v1nfba"
                },
                8: {
                    conditions: {
                        mobile: "_1y2v1nfbd",
                        tablet: "_1y2v1nfbe",
                        desktop: "_1y2v1nfbf"
                    },
                    defaultClass: "_1y2v1nfbd"
                },
                12: {
                    conditions: {
                        mobile: "_1y2v1nfbg",
                        tablet: "_1y2v1nfbh",
                        desktop: "_1y2v1nfbi"
                    },
                    defaultClass: "_1y2v1nfbg"
                },
                16: {
                    conditions: {
                        mobile: "_1y2v1nfbj",
                        tablet: "_1y2v1nfbk",
                        desktop: "_1y2v1nfbl"
                    },
                    defaultClass: "_1y2v1nfbj"
                },
                20: {
                    conditions: {
                        mobile: "_1y2v1nfbm",
                        tablet: "_1y2v1nfbn",
                        desktop: "_1y2v1nfbo"
                    },
                    defaultClass: "_1y2v1nfbm"
                },
                24: {
                    conditions: {
                        mobile: "_1y2v1nfbp",
                        tablet: "_1y2v1nfbq",
                        desktop: "_1y2v1nfbr"
                    },
                    defaultClass: "_1y2v1nfbp"
                },
                32: {
                    conditions: {
                        mobile: "_1y2v1nfbs",
                        tablet: "_1y2v1nfbt",
                        desktop: "_1y2v1nfbu"
                    },
                    defaultClass: "_1y2v1nfbs"
                },
                40: {
                    conditions: {
                        mobile: "_1y2v1nfbv",
                        tablet: "_1y2v1nfbw",
                        desktop: "_1y2v1nfbx"
                    },
                    defaultClass: "_1y2v1nfbv"
                },
                48: {
                    conditions: {
                        mobile: "_1y2v1nfby",
                        tablet: "_1y2v1nfbz",
                        desktop: "_1y2v1nfc0"
                    },
                    defaultClass: "_1y2v1nfby"
                },
                56: {
                    conditions: {
                        mobile: "_1y2v1nfc1",
                        tablet: "_1y2v1nfc2",
                        desktop: "_1y2v1nfc3"
                    },
                    defaultClass: "_1y2v1nfc1"
                },
                64: {
                    conditions: {
                        mobile: "_1y2v1nfc4",
                        tablet: "_1y2v1nfc5",
                        desktop: "_1y2v1nfc6"
                    },
                    defaultClass: "_1y2v1nfc4"
                },
                72: {
                    conditions: {
                        mobile: "_1y2v1nfc7",
                        tablet: "_1y2v1nfc8",
                        desktop: "_1y2v1nfc9"
                    },
                    defaultClass: "_1y2v1nfc7"
                },
                80: {
                    conditions: {
                        mobile: "_1y2v1nfca",
                        tablet: "_1y2v1nfcb",
                        desktop: "_1y2v1nfcc"
                    },
                    defaultClass: "_1y2v1nfca"
                }
            }
        },
        columnGap: {
            values: {
                0: {
                    conditions: {
                        mobile: "_1y2v1nfcd",
                        tablet: "_1y2v1nfce",
                        desktop: "_1y2v1nfcf"
                    },
                    defaultClass: "_1y2v1nfcd"
                },
                2: {
                    conditions: {
                        mobile: "_1y2v1nfcg",
                        tablet: "_1y2v1nfch",
                        desktop: "_1y2v1nfci"
                    },
                    defaultClass: "_1y2v1nfcg"
                },
                4: {
                    conditions: {
                        mobile: "_1y2v1nfcj",
                        tablet: "_1y2v1nfck",
                        desktop: "_1y2v1nfcl"
                    },
                    defaultClass: "_1y2v1nfcj"
                },
                8: {
                    conditions: {
                        mobile: "_1y2v1nfcm",
                        tablet: "_1y2v1nfcn",
                        desktop: "_1y2v1nfco"
                    },
                    defaultClass: "_1y2v1nfcm"
                },
                12: {
                    conditions: {
                        mobile: "_1y2v1nfcp",
                        tablet: "_1y2v1nfcq",
                        desktop: "_1y2v1nfcr"
                    },
                    defaultClass: "_1y2v1nfcp"
                },
                16: {
                    conditions: {
                        mobile: "_1y2v1nfcs",
                        tablet: "_1y2v1nfct",
                        desktop: "_1y2v1nfcu"
                    },
                    defaultClass: "_1y2v1nfcs"
                },
                20: {
                    conditions: {
                        mobile: "_1y2v1nfcv",
                        tablet: "_1y2v1nfcw",
                        desktop: "_1y2v1nfcx"
                    },
                    defaultClass: "_1y2v1nfcv"
                },
                24: {
                    conditions: {
                        mobile: "_1y2v1nfcy",
                        tablet: "_1y2v1nfcz",
                        desktop: "_1y2v1nfd0"
                    },
                    defaultClass: "_1y2v1nfcy"
                },
                32: {
                    conditions: {
                        mobile: "_1y2v1nfd1",
                        tablet: "_1y2v1nfd2",
                        desktop: "_1y2v1nfd3"
                    },
                    defaultClass: "_1y2v1nfd1"
                },
                40: {
                    conditions: {
                        mobile: "_1y2v1nfd4",
                        tablet: "_1y2v1nfd5",
                        desktop: "_1y2v1nfd6"
                    },
                    defaultClass: "_1y2v1nfd4"
                },
                48: {
                    conditions: {
                        mobile: "_1y2v1nfd7",
                        tablet: "_1y2v1nfd8",
                        desktop: "_1y2v1nfd9"
                    },
                    defaultClass: "_1y2v1nfd7"
                },
                56: {
                    conditions: {
                        mobile: "_1y2v1nfda",
                        tablet: "_1y2v1nfdb",
                        desktop: "_1y2v1nfdc"
                    },
                    defaultClass: "_1y2v1nfda"
                },
                64: {
                    conditions: {
                        mobile: "_1y2v1nfdd",
                        tablet: "_1y2v1nfde",
                        desktop: "_1y2v1nfdf"
                    },
                    defaultClass: "_1y2v1nfdd"
                },
                72: {
                    conditions: {
                        mobile: "_1y2v1nfdg",
                        tablet: "_1y2v1nfdh",
                        desktop: "_1y2v1nfdi"
                    },
                    defaultClass: "_1y2v1nfdg"
                },
                80: {
                    conditions: {
                        mobile: "_1y2v1nfdj",
                        tablet: "_1y2v1nfdk",
                        desktop: "_1y2v1nfdl"
                    },
                    defaultClass: "_1y2v1nfdj"
                }
            }
        },
        rowGap: {
            values: {
                0: {
                    conditions: {
                        mobile: "_1y2v1nfdm",
                        tablet: "_1y2v1nfdn",
                        desktop: "_1y2v1nfdo"
                    },
                    defaultClass: "_1y2v1nfdm"
                },
                2: {
                    conditions: {
                        mobile: "_1y2v1nfdp",
                        tablet: "_1y2v1nfdq",
                        desktop: "_1y2v1nfdr"
                    },
                    defaultClass: "_1y2v1nfdp"
                },
                4: {
                    conditions: {
                        mobile: "_1y2v1nfds",
                        tablet: "_1y2v1nfdt",
                        desktop: "_1y2v1nfdu"
                    },
                    defaultClass: "_1y2v1nfds"
                },
                8: {
                    conditions: {
                        mobile: "_1y2v1nfdv",
                        tablet: "_1y2v1nfdw",
                        desktop: "_1y2v1nfdx"
                    },
                    defaultClass: "_1y2v1nfdv"
                },
                12: {
                    conditions: {
                        mobile: "_1y2v1nfdy",
                        tablet: "_1y2v1nfdz",
                        desktop: "_1y2v1nfe0"
                    },
                    defaultClass: "_1y2v1nfdy"
                },
                16: {
                    conditions: {
                        mobile: "_1y2v1nfe1",
                        tablet: "_1y2v1nfe2",
                        desktop: "_1y2v1nfe3"
                    },
                    defaultClass: "_1y2v1nfe1"
                },
                20: {
                    conditions: {
                        mobile: "_1y2v1nfe4",
                        tablet: "_1y2v1nfe5",
                        desktop: "_1y2v1nfe6"
                    },
                    defaultClass: "_1y2v1nfe4"
                },
                24: {
                    conditions: {
                        mobile: "_1y2v1nfe7",
                        tablet: "_1y2v1nfe8",
                        desktop: "_1y2v1nfe9"
                    },
                    defaultClass: "_1y2v1nfe7"
                },
                32: {
                    conditions: {
                        mobile: "_1y2v1nfea",
                        tablet: "_1y2v1nfeb",
                        desktop: "_1y2v1nfec"
                    },
                    defaultClass: "_1y2v1nfea"
                },
                40: {
                    conditions: {
                        mobile: "_1y2v1nfed",
                        tablet: "_1y2v1nfee",
                        desktop: "_1y2v1nfef"
                    },
                    defaultClass: "_1y2v1nfed"
                },
                48: {
                    conditions: {
                        mobile: "_1y2v1nfeg",
                        tablet: "_1y2v1nfeh",
                        desktop: "_1y2v1nfei"
                    },
                    defaultClass: "_1y2v1nfeg"
                },
                56: {
                    conditions: {
                        mobile: "_1y2v1nfej",
                        tablet: "_1y2v1nfek",
                        desktop: "_1y2v1nfel"
                    },
                    defaultClass: "_1y2v1nfej"
                },
                64: {
                    conditions: {
                        mobile: "_1y2v1nfem",
                        tablet: "_1y2v1nfen",
                        desktop: "_1y2v1nfeo"
                    },
                    defaultClass: "_1y2v1nfem"
                },
                72: {
                    conditions: {
                        mobile: "_1y2v1nfep",
                        tablet: "_1y2v1nfeq",
                        desktop: "_1y2v1nfer"
                    },
                    defaultClass: "_1y2v1nfep"
                },
                80: {
                    conditions: {
                        mobile: "_1y2v1nfes",
                        tablet: "_1y2v1nfet",
                        desktop: "_1y2v1nfeu"
                    },
                    defaultClass: "_1y2v1nfes"
                }
            }
        },
        gridColumnGap: {
            values: {
                0: {
                    conditions: {
                        mobile: "_1y2v1nfev",
                        tablet: "_1y2v1nfew",
                        desktop: "_1y2v1nfex"
                    },
                    defaultClass: "_1y2v1nfev"
                },
                2: {
                    conditions: {
                        mobile: "_1y2v1nfey",
                        tablet: "_1y2v1nfez",
                        desktop: "_1y2v1nff0"
                    },
                    defaultClass: "_1y2v1nfey"
                },
                4: {
                    conditions: {
                        mobile: "_1y2v1nff1",
                        tablet: "_1y2v1nff2",
                        desktop: "_1y2v1nff3"
                    },
                    defaultClass: "_1y2v1nff1"
                },
                8: {
                    conditions: {
                        mobile: "_1y2v1nff4",
                        tablet: "_1y2v1nff5",
                        desktop: "_1y2v1nff6"
                    },
                    defaultClass: "_1y2v1nff4"
                },
                12: {
                    conditions: {
                        mobile: "_1y2v1nff7",
                        tablet: "_1y2v1nff8",
                        desktop: "_1y2v1nff9"
                    },
                    defaultClass: "_1y2v1nff7"
                },
                16: {
                    conditions: {
                        mobile: "_1y2v1nffa",
                        tablet: "_1y2v1nffb",
                        desktop: "_1y2v1nffc"
                    },
                    defaultClass: "_1y2v1nffa"
                },
                20: {
                    conditions: {
                        mobile: "_1y2v1nffd",
                        tablet: "_1y2v1nffe",
                        desktop: "_1y2v1nfff"
                    },
                    defaultClass: "_1y2v1nffd"
                },
                24: {
                    conditions: {
                        mobile: "_1y2v1nffg",
                        tablet: "_1y2v1nffh",
                        desktop: "_1y2v1nffi"
                    },
                    defaultClass: "_1y2v1nffg"
                },
                32: {
                    conditions: {
                        mobile: "_1y2v1nffj",
                        tablet: "_1y2v1nffk",
                        desktop: "_1y2v1nffl"
                    },
                    defaultClass: "_1y2v1nffj"
                },
                40: {
                    conditions: {
                        mobile: "_1y2v1nffm",
                        tablet: "_1y2v1nffn",
                        desktop: "_1y2v1nffo"
                    },
                    defaultClass: "_1y2v1nffm"
                },
                48: {
                    conditions: {
                        mobile: "_1y2v1nffp",
                        tablet: "_1y2v1nffq",
                        desktop: "_1y2v1nffr"
                    },
                    defaultClass: "_1y2v1nffp"
                },
                56: {
                    conditions: {
                        mobile: "_1y2v1nffs",
                        tablet: "_1y2v1nfft",
                        desktop: "_1y2v1nffu"
                    },
                    defaultClass: "_1y2v1nffs"
                },
                64: {
                    conditions: {
                        mobile: "_1y2v1nffv",
                        tablet: "_1y2v1nffw",
                        desktop: "_1y2v1nffx"
                    },
                    defaultClass: "_1y2v1nffv"
                },
                72: {
                    conditions: {
                        mobile: "_1y2v1nffy",
                        tablet: "_1y2v1nffz",
                        desktop: "_1y2v1nfg0"
                    },
                    defaultClass: "_1y2v1nffy"
                },
                80: {
                    conditions: {
                        mobile: "_1y2v1nfg1",
                        tablet: "_1y2v1nfg2",
                        desktop: "_1y2v1nfg3"
                    },
                    defaultClass: "_1y2v1nfg1"
                }
            }
        },
        gridRowGap: {
            values: {
                0: {
                    conditions: {
                        mobile: "_1y2v1nfg4",
                        tablet: "_1y2v1nfg5",
                        desktop: "_1y2v1nfg6"
                    },
                    defaultClass: "_1y2v1nfg4"
                },
                2: {
                    conditions: {
                        mobile: "_1y2v1nfg7",
                        tablet: "_1y2v1nfg8",
                        desktop: "_1y2v1nfg9"
                    },
                    defaultClass: "_1y2v1nfg7"
                },
                4: {
                    conditions: {
                        mobile: "_1y2v1nfga",
                        tablet: "_1y2v1nfgb",
                        desktop: "_1y2v1nfgc"
                    },
                    defaultClass: "_1y2v1nfga"
                },
                8: {
                    conditions: {
                        mobile: "_1y2v1nfgd",
                        tablet: "_1y2v1nfge",
                        desktop: "_1y2v1nfgf"
                    },
                    defaultClass: "_1y2v1nfgd"
                },
                12: {
                    conditions: {
                        mobile: "_1y2v1nfgg",
                        tablet: "_1y2v1nfgh",
                        desktop: "_1y2v1nfgi"
                    },
                    defaultClass: "_1y2v1nfgg"
                },
                16: {
                    conditions: {
                        mobile: "_1y2v1nfgj",
                        tablet: "_1y2v1nfgk",
                        desktop: "_1y2v1nfgl"
                    },
                    defaultClass: "_1y2v1nfgj"
                },
                20: {
                    conditions: {
                        mobile: "_1y2v1nfgm",
                        tablet: "_1y2v1nfgn",
                        desktop: "_1y2v1nfgo"
                    },
                    defaultClass: "_1y2v1nfgm"
                },
                24: {
                    conditions: {
                        mobile: "_1y2v1nfgp",
                        tablet: "_1y2v1nfgq",
                        desktop: "_1y2v1nfgr"
                    },
                    defaultClass: "_1y2v1nfgp"
                },
                32: {
                    conditions: {
                        mobile: "_1y2v1nfgs",
                        tablet: "_1y2v1nfgt",
                        desktop: "_1y2v1nfgu"
                    },
                    defaultClass: "_1y2v1nfgs"
                },
                40: {
                    conditions: {
                        mobile: "_1y2v1nfgv",
                        tablet: "_1y2v1nfgw",
                        desktop: "_1y2v1nfgx"
                    },
                    defaultClass: "_1y2v1nfgv"
                },
                48: {
                    conditions: {
                        mobile: "_1y2v1nfgy",
                        tablet: "_1y2v1nfgz",
                        desktop: "_1y2v1nfh0"
                    },
                    defaultClass: "_1y2v1nfgy"
                },
                56: {
                    conditions: {
                        mobile: "_1y2v1nfh1",
                        tablet: "_1y2v1nfh2",
                        desktop: "_1y2v1nfh3"
                    },
                    defaultClass: "_1y2v1nfh1"
                },
                64: {
                    conditions: {
                        mobile: "_1y2v1nfh4",
                        tablet: "_1y2v1nfh5",
                        desktop: "_1y2v1nfh6"
                    },
                    defaultClass: "_1y2v1nfh4"
                },
                72: {
                    conditions: {
                        mobile: "_1y2v1nfh7",
                        tablet: "_1y2v1nfh8",
                        desktop: "_1y2v1nfh9"
                    },
                    defaultClass: "_1y2v1nfh7"
                },
                80: {
                    conditions: {
                        mobile: "_1y2v1nfha",
                        tablet: "_1y2v1nfhb",
                        desktop: "_1y2v1nfhc"
                    },
                    defaultClass: "_1y2v1nfha"
                }
            }
        }
    }
}, {
    conditions: void 0,
    styles: {
        color: {
            values: {
                "var(--_1vqcj1i0)": {
                    defaultClass: "_1y2v1nf0"
                },
                "var(--_1vqcj1i1)": {
                    defaultClass: "_1y2v1nf1"
                },
                "var(--_1vqcj1i2)": {
                    defaultClass: "_1y2v1nf2"
                },
                "var(--_1vqcj1i3)": {
                    defaultClass: "_1y2v1nf3"
                },
                "var(--_1vqcj1i4)": {
                    defaultClass: "_1y2v1nf4"
                },
                "var(--_1vqcj1i5)": {
                    defaultClass: "_1y2v1nf5"
                },
                "var(--_1vqcj1i6)": {
                    defaultClass: "_1y2v1nf6"
                },
                "var(--_1vqcj1i7)": {
                    defaultClass: "_1y2v1nf7"
                },
                "var(--_1vqcj1i8)": {
                    defaultClass: "_1y2v1nf8"
                },
                "var(--_1vqcj1i9)": {
                    defaultClass: "_1y2v1nf9"
                },
                "var(--_1vqcj1ia)": {
                    defaultClass: "_1y2v1nfa"
                },
                "var(--_1vqcj1ib)": {
                    defaultClass: "_1y2v1nfb"
                },
                "var(--_1vqcj1ic)": {
                    defaultClass: "_1y2v1nfc"
                },
                "var(--_1vqcj1id)": {
                    defaultClass: "_1y2v1nfd"
                },
                "var(--_1vqcj1ie)": {
                    defaultClass: "_1y2v1nfe"
                },
                "var(--_1vqcj1if)": {
                    defaultClass: "_1y2v1nff"
                },
                "var(--_1vqcj1ig)": {
                    defaultClass: "_1y2v1nfg"
                },
                "var(--_1vqcj1ih)": {
                    defaultClass: "_1y2v1nfh"
                },
                "var(--_1vqcj1ii)": {
                    defaultClass: "_1y2v1nfi"
                },
                "var(--_1vqcj1ij)": {
                    defaultClass: "_1y2v1nfj"
                },
                "var(--_1vqcj1ik)": {
                    defaultClass: "_1y2v1nfk"
                },
                "var(--_1vqcj1il)": {
                    defaultClass: "_1y2v1nfl"
                },
                "var(--_1vqcj1im)": {
                    defaultClass: "_1y2v1nfm"
                },
                "var(--_1vqcj1in)": {
                    defaultClass: "_1y2v1nfn"
                },
                "var(--_1vqcj1io)": {
                    defaultClass: "_1y2v1nfo"
                },
                "var(--_1vqcj1ip)": {
                    defaultClass: "_1y2v1nfp"
                },
                "var(--_1vqcj1iq)": {
                    defaultClass: "_1y2v1nfq"
                },
                "var(--_1vqcj1ir)": {
                    defaultClass: "_1y2v1nfr"
                },
                "var(--_1vqcj1is)": {
                    defaultClass: "_1y2v1nfs"
                },
                "var(--_1vqcj1it)": {
                    defaultClass: "_1y2v1nft"
                },
                "var(--_1vqcj1iu)": {
                    defaultClass: "_1y2v1nfu"
                },
                "var(--_1vqcj1iv)": {
                    defaultClass: "_1y2v1nfv"
                },
                "var(--_1vqcj1iw)": {
                    defaultClass: "_1y2v1nfw"
                },
                "var(--_1vqcj1ix)": {
                    defaultClass: "_1y2v1nfx"
                },
                "var(--_1vqcj1iy)": {
                    defaultClass: "_1y2v1nfy"
                },
                "var(--_1vqcj1iz)": {
                    defaultClass: "_1y2v1nfz"
                },
                "var(--_1vqcj1i10)": {
                    defaultClass: "_1y2v1nf10"
                },
                "var(--_1vqcj1i11)": {
                    defaultClass: "_1y2v1nf11"
                },
                "var(--_1vqcj1i12)": {
                    defaultClass: "_1y2v1nf12"
                },
                "var(--_1vqcj1i13)": {
                    defaultClass: "_1y2v1nf13"
                },
                "var(--_1vqcj1i14)": {
                    defaultClass: "_1y2v1nf14"
                },
                "var(--_1vqcj1i15)": {
                    defaultClass: "_1y2v1nf15"
                },
                "var(--_1vqcj1i16)": {
                    defaultClass: "_1y2v1nf16"
                },
                "var(--_1vqcj1i17)": {
                    defaultClass: "_1y2v1nf17"
                },
                "var(--_1vqcj1i18)": {
                    defaultClass: "_1y2v1nf18"
                },
                "var(--_1vqcj1i19)": {
                    defaultClass: "_1y2v1nf19"
                },
                "var(--_1vqcj1i1a)": {
                    defaultClass: "_1y2v1nf1a"
                },
                "var(--_1vqcj1i1b)": {
                    defaultClass: "_1y2v1nf1b"
                },
                "var(--_1vqcj1i1c)": {
                    defaultClass: "_1y2v1nf1c"
                },
                "var(--_1vqcj1i1d)": {
                    defaultClass: "_1y2v1nf1d"
                },
                "var(--_1vqcj1i1e)": {
                    defaultClass: "_1y2v1nf1e"
                },
                "var(--_1vqcj1i1f)": {
                    defaultClass: "_1y2v1nf1f"
                },
                "var(--_1vqcj1i1g)": {
                    defaultClass: "_1y2v1nf1g"
                },
                "var(--_1vqcj1i1h)": {
                    defaultClass: "_1y2v1nf1h"
                },
                "var(--_1vqcj1i1i)": {
                    defaultClass: "_1y2v1nf1i"
                },
                "var(--_1vqcj1i1j)": {
                    defaultClass: "_1y2v1nf1j"
                },
                "var(--_1vqcj1i1k)": {
                    defaultClass: "_1y2v1nf1k"
                },
                "var(--_1vqcj1i1l)": {
                    defaultClass: "_1y2v1nf1l"
                },
                "var(--_1vqcj1i1m)": {
                    defaultClass: "_1y2v1nf1m"
                },
                "var(--_1vqcj1i1n)": {
                    defaultClass: "_1y2v1nf1n"
                },
                "var(--_1vqcj1i1o)": {
                    defaultClass: "_1y2v1nf1o"
                },
                "var(--_1vqcj1i1p)": {
                    defaultClass: "_1y2v1nf1p"
                },
                "var(--_1vqcj1i1q)": {
                    defaultClass: "_1y2v1nf1q"
                },
                "var(--_1vqcj1i1r)": {
                    defaultClass: "_1y2v1nf1r"
                },
                "var(--_1vqcj1i1s)": {
                    defaultClass: "_1y2v1nf1s"
                },
                "var(--_1vqcj1i1t)": {
                    defaultClass: "_1y2v1nf1t"
                },
                "var(--_1vqcj1i1u)": {
                    defaultClass: "_1y2v1nf1u"
                },
                "var(--_1vqcj1i1v)": {
                    defaultClass: "_1y2v1nf1v"
                },
                "var(--_1vqcj1i1w)": {
                    defaultClass: "_1y2v1nf1w"
                },
                "var(--_1vqcj1i1x)": {
                    defaultClass: "_1y2v1nf1x"
                },
                "var(--_1vqcj1i1y)": {
                    defaultClass: "_1y2v1nf1y"
                },
                "var(--_1vqcj1i1z)": {
                    defaultClass: "_1y2v1nf1z"
                },
                "var(--_1vqcj1i20)": {
                    defaultClass: "_1y2v1nf20"
                },
                "var(--_1vqcj1i21)": {
                    defaultClass: "_1y2v1nf21"
                },
                "var(--_1vqcj1i22)": {
                    defaultClass: "_1y2v1nf22"
                },
                "var(--_1vqcj1i23)": {
                    defaultClass: "_1y2v1nf23"
                },
                "var(--_1vqcj1i24)": {
                    defaultClass: "_1y2v1nf24"
                },
                "var(--_1vqcj1i25)": {
                    defaultClass: "_1y2v1nf25"
                },
                "var(--_1vqcj1i26)": {
                    defaultClass: "_1y2v1nf26"
                },
                "var(--_1vqcj1i27)": {
                    defaultClass: "_1y2v1nf27"
                },
                "var(--_1vqcj1i28)": {
                    defaultClass: "_1y2v1nf28"
                },
                "var(--_1vqcj1i29)": {
                    defaultClass: "_1y2v1nf29"
                },
                "var(--_1vqcj1i2a)": {
                    defaultClass: "_1y2v1nf2a"
                },
                "var(--_1vqcj1i2b)": {
                    defaultClass: "_1y2v1nf2b"
                },
                "var(--_1vqcj1i2c)": {
                    defaultClass: "_1y2v1nf2c"
                },
                "var(--_1vqcj1i2d)": {
                    defaultClass: "_1y2v1nf2d"
                },
                "var(--_1vqcj1i2e)": {
                    defaultClass: "_1y2v1nf2e"
                },
                "var(--_1vqcj1i2f)": {
                    defaultClass: "_1y2v1nf2f"
                },
                "var(--_1vqcj1i2g)": {
                    defaultClass: "_1y2v1nf2g"
                },
                "var(--_1vqcj1i2h)": {
                    defaultClass: "_1y2v1nf2h"
                },
                "var(--_1vqcj1i2i)": {
                    defaultClass: "_1y2v1nf2i"
                },
                "var(--_1vqcj1i2j)": {
                    defaultClass: "_1y2v1nf2j"
                },
                "var(--_1vqcj1i2k)": {
                    defaultClass: "_1y2v1nf2k"
                },
                "var(--_1vqcj1i2l)": {
                    defaultClass: "_1y2v1nf2l"
                },
                "var(--_1vqcj1i2m)": {
                    defaultClass: "_1y2v1nf2m"
                },
                "var(--_1vqcj1i2n)": {
                    defaultClass: "_1y2v1nf2n"
                },
                "var(--_1vqcj1i2o)": {
                    defaultClass: "_1y2v1nf2o"
                },
                "var(--_1vqcj1i2p)": {
                    defaultClass: "_1y2v1nf2p"
                },
                "var(--_1vqcj1i2q)": {
                    defaultClass: "_1y2v1nf2q"
                },
                "var(--_1vqcj1i2r)": {
                    defaultClass: "_1y2v1nf2r"
                },
                "var(--_1vqcj1i2s)": {
                    defaultClass: "_1y2v1nf2s"
                },
                "var(--_1vqcj1i2t)": {
                    defaultClass: "_1y2v1nf2t"
                },
                "var(--_1vqcj1i2u)": {
                    defaultClass: "_1y2v1nf2u"
                },
                "var(--_1vqcj1i2v)": {
                    defaultClass: "_1y2v1nf2v"
                },
                "var(--_1vqcj1i2w)": {
                    defaultClass: "_1y2v1nf2w"
                },
                "var(--_1vqcj1i2x)": {
                    defaultClass: "_1y2v1nf2x"
                },
                "var(--_1vqcj1i2y)": {
                    defaultClass: "_1y2v1nf2y"
                },
                "var(--_1vqcj1i2z)": {
                    defaultClass: "_1y2v1nf2z"
                },
                "var(--_1vqcj1i30)": {
                    defaultClass: "_1y2v1nf30"
                },
                "var(--_1vqcj1i31)": {
                    defaultClass: "_1y2v1nf31"
                },
                "var(--_1vqcj1i32)": {
                    defaultClass: "_1y2v1nf32"
                },
                "var(--_1vqcj1i33)": {
                    defaultClass: "_1y2v1nf33"
                },
                "var(--_1vqcj1i34)": {
                    defaultClass: "_1y2v1nf34"
                },
                "var(--_1vqcj1i35)": {
                    defaultClass: "_1y2v1nf35"
                },
                "var(--_1vqcj1i36)": {
                    defaultClass: "_1y2v1nf36"
                },
                "var(--_1vqcj1i37)": {
                    defaultClass: "_1y2v1nf37"
                },
                "var(--_1vqcj1i38)": {
                    defaultClass: "_1y2v1nf38"
                },
                "var(--_1vqcj1i39)": {
                    defaultClass: "_1y2v1nf39"
                },
                "var(--_1vqcj1i3a)": {
                    defaultClass: "_1y2v1nf3a"
                },
                "var(--_1vqcj1i3b)": {
                    defaultClass: "_1y2v1nf3b"
                },
                "var(--_1vqcj1i3c)": {
                    defaultClass: "_1y2v1nf3c"
                },
                "var(--_1vqcj1i3d)": {
                    defaultClass: "_1y2v1nf3d"
                },
                "var(--_1vqcj1i3e)": {
                    defaultClass: "_1y2v1nf3e"
                },
                "var(--_1vqcj1i3f)": {
                    defaultClass: "_1y2v1nf3f"
                },
                "var(--_1vqcj1i3g)": {
                    defaultClass: "_1y2v1nf3g"
                },
                "var(--_1vqcj1i3h)": {
                    defaultClass: "_1y2v1nf3h"
                },
                "var(--_1vqcj1i3i)": {
                    defaultClass: "_1y2v1nf3i"
                },
                "var(--_1vqcj1i3j)": {
                    defaultClass: "_1y2v1nf3j"
                },
                "var(--_1vqcj1i3k)": {
                    defaultClass: "_1y2v1nf3k"
                },
                "var(--_1vqcj1i3l)": {
                    defaultClass: "_1y2v1nf3l"
                },
                transparent: {
                    defaultClass: "_1y2v1nf3m"
                },
                inherit: {
                    defaultClass: "_1y2v1nf3n"
                }
            }
        },
        background: {
            values: {
                "var(--_1vqcj1i0)": {
                    defaultClass: "_1y2v1nf3o"
                },
                "var(--_1vqcj1i1)": {
                    defaultClass: "_1y2v1nf3p"
                },
                "var(--_1vqcj1i2)": {
                    defaultClass: "_1y2v1nf3q"
                },
                "var(--_1vqcj1i3)": {
                    defaultClass: "_1y2v1nf3r"
                },
                "var(--_1vqcj1i4)": {
                    defaultClass: "_1y2v1nf3s"
                },
                "var(--_1vqcj1i5)": {
                    defaultClass: "_1y2v1nf3t"
                },
                "var(--_1vqcj1i6)": {
                    defaultClass: "_1y2v1nf3u"
                },
                "var(--_1vqcj1i7)": {
                    defaultClass: "_1y2v1nf3v"
                },
                "var(--_1vqcj1i8)": {
                    defaultClass: "_1y2v1nf3w"
                },
                "var(--_1vqcj1i9)": {
                    defaultClass: "_1y2v1nf3x"
                },
                "var(--_1vqcj1ia)": {
                    defaultClass: "_1y2v1nf3y"
                },
                "var(--_1vqcj1ib)": {
                    defaultClass: "_1y2v1nf3z"
                },
                "var(--_1vqcj1ic)": {
                    defaultClass: "_1y2v1nf40"
                },
                "var(--_1vqcj1id)": {
                    defaultClass: "_1y2v1nf41"
                },
                "var(--_1vqcj1ie)": {
                    defaultClass: "_1y2v1nf42"
                },
                "var(--_1vqcj1if)": {
                    defaultClass: "_1y2v1nf43"
                },
                "var(--_1vqcj1ig)": {
                    defaultClass: "_1y2v1nf44"
                },
                "var(--_1vqcj1ih)": {
                    defaultClass: "_1y2v1nf45"
                },
                "var(--_1vqcj1ii)": {
                    defaultClass: "_1y2v1nf46"
                },
                "var(--_1vqcj1ij)": {
                    defaultClass: "_1y2v1nf47"
                },
                "var(--_1vqcj1ik)": {
                    defaultClass: "_1y2v1nf48"
                },
                "var(--_1vqcj1il)": {
                    defaultClass: "_1y2v1nf49"
                },
                "var(--_1vqcj1im)": {
                    defaultClass: "_1y2v1nf4a"
                },
                "var(--_1vqcj1in)": {
                    defaultClass: "_1y2v1nf4b"
                },
                "var(--_1vqcj1io)": {
                    defaultClass: "_1y2v1nf4c"
                },
                "var(--_1vqcj1ip)": {
                    defaultClass: "_1y2v1nf4d"
                },
                "var(--_1vqcj1iq)": {
                    defaultClass: "_1y2v1nf4e"
                },
                "var(--_1vqcj1ir)": {
                    defaultClass: "_1y2v1nf4f"
                },
                "var(--_1vqcj1is)": {
                    defaultClass: "_1y2v1nf4g"
                },
                "var(--_1vqcj1it)": {
                    defaultClass: "_1y2v1nf4h"
                },
                "var(--_1vqcj1iu)": {
                    defaultClass: "_1y2v1nf4i"
                },
                "var(--_1vqcj1iv)": {
                    defaultClass: "_1y2v1nf4j"
                },
                "var(--_1vqcj1iw)": {
                    defaultClass: "_1y2v1nf4k"
                },
                "var(--_1vqcj1ix)": {
                    defaultClass: "_1y2v1nf4l"
                },
                "var(--_1vqcj1iy)": {
                    defaultClass: "_1y2v1nf4m"
                },
                "var(--_1vqcj1iz)": {
                    defaultClass: "_1y2v1nf4n"
                },
                "var(--_1vqcj1i10)": {
                    defaultClass: "_1y2v1nf4o"
                },
                "var(--_1vqcj1i11)": {
                    defaultClass: "_1y2v1nf4p"
                },
                "var(--_1vqcj1i12)": {
                    defaultClass: "_1y2v1nf4q"
                },
                "var(--_1vqcj1i13)": {
                    defaultClass: "_1y2v1nf4r"
                },
                "var(--_1vqcj1i14)": {
                    defaultClass: "_1y2v1nf4s"
                },
                "var(--_1vqcj1i15)": {
                    defaultClass: "_1y2v1nf4t"
                },
                "var(--_1vqcj1i16)": {
                    defaultClass: "_1y2v1nf4u"
                },
                "var(--_1vqcj1i17)": {
                    defaultClass: "_1y2v1nf4v"
                },
                "var(--_1vqcj1i18)": {
                    defaultClass: "_1y2v1nf4w"
                },
                "var(--_1vqcj1i19)": {
                    defaultClass: "_1y2v1nf4x"
                },
                "var(--_1vqcj1i1a)": {
                    defaultClass: "_1y2v1nf4y"
                },
                "var(--_1vqcj1i1b)": {
                    defaultClass: "_1y2v1nf4z"
                },
                "var(--_1vqcj1i1c)": {
                    defaultClass: "_1y2v1nf50"
                },
                "var(--_1vqcj1i1d)": {
                    defaultClass: "_1y2v1nf51"
                },
                "var(--_1vqcj1i1e)": {
                    defaultClass: "_1y2v1nf52"
                },
                "var(--_1vqcj1i1f)": {
                    defaultClass: "_1y2v1nf53"
                },
                "var(--_1vqcj1i1g)": {
                    defaultClass: "_1y2v1nf54"
                },
                "var(--_1vqcj1i1h)": {
                    defaultClass: "_1y2v1nf55"
                },
                "var(--_1vqcj1i1i)": {
                    defaultClass: "_1y2v1nf56"
                },
                "var(--_1vqcj1i1j)": {
                    defaultClass: "_1y2v1nf57"
                },
                "var(--_1vqcj1i1k)": {
                    defaultClass: "_1y2v1nf58"
                },
                "var(--_1vqcj1i1l)": {
                    defaultClass: "_1y2v1nf59"
                },
                "var(--_1vqcj1i1m)": {
                    defaultClass: "_1y2v1nf5a"
                },
                "var(--_1vqcj1i1n)": {
                    defaultClass: "_1y2v1nf5b"
                },
                "var(--_1vqcj1i1o)": {
                    defaultClass: "_1y2v1nf5c"
                },
                "var(--_1vqcj1i1p)": {
                    defaultClass: "_1y2v1nf5d"
                },
                "var(--_1vqcj1i1q)": {
                    defaultClass: "_1y2v1nf5e"
                },
                "var(--_1vqcj1i1r)": {
                    defaultClass: "_1y2v1nf5f"
                },
                "var(--_1vqcj1i1s)": {
                    defaultClass: "_1y2v1nf5g"
                },
                "var(--_1vqcj1i1t)": {
                    defaultClass: "_1y2v1nf5h"
                },
                "var(--_1vqcj1i1u)": {
                    defaultClass: "_1y2v1nf5i"
                },
                "var(--_1vqcj1i1v)": {
                    defaultClass: "_1y2v1nf5j"
                },
                "var(--_1vqcj1i1w)": {
                    defaultClass: "_1y2v1nf5k"
                },
                "var(--_1vqcj1i1x)": {
                    defaultClass: "_1y2v1nf5l"
                },
                "var(--_1vqcj1i1y)": {
                    defaultClass: "_1y2v1nf5m"
                },
                "var(--_1vqcj1i1z)": {
                    defaultClass: "_1y2v1nf5n"
                },
                "var(--_1vqcj1i20)": {
                    defaultClass: "_1y2v1nf5o"
                },
                "var(--_1vqcj1i21)": {
                    defaultClass: "_1y2v1nf5p"
                },
                "var(--_1vqcj1i22)": {
                    defaultClass: "_1y2v1nf5q"
                },
                "var(--_1vqcj1i23)": {
                    defaultClass: "_1y2v1nf5r"
                },
                "var(--_1vqcj1i24)": {
                    defaultClass: "_1y2v1nf5s"
                },
                "var(--_1vqcj1i25)": {
                    defaultClass: "_1y2v1nf5t"
                },
                "var(--_1vqcj1i26)": {
                    defaultClass: "_1y2v1nf5u"
                },
                "var(--_1vqcj1i27)": {
                    defaultClass: "_1y2v1nf5v"
                },
                "var(--_1vqcj1i28)": {
                    defaultClass: "_1y2v1nf5w"
                },
                "var(--_1vqcj1i29)": {
                    defaultClass: "_1y2v1nf5x"
                },
                "var(--_1vqcj1i2a)": {
                    defaultClass: "_1y2v1nf5y"
                },
                "var(--_1vqcj1i2b)": {
                    defaultClass: "_1y2v1nf5z"
                },
                "var(--_1vqcj1i2c)": {
                    defaultClass: "_1y2v1nf60"
                },
                "var(--_1vqcj1i2d)": {
                    defaultClass: "_1y2v1nf61"
                },
                "var(--_1vqcj1i2e)": {
                    defaultClass: "_1y2v1nf62"
                },
                "var(--_1vqcj1i2f)": {
                    defaultClass: "_1y2v1nf63"
                },
                "var(--_1vqcj1i2g)": {
                    defaultClass: "_1y2v1nf64"
                },
                "var(--_1vqcj1i2h)": {
                    defaultClass: "_1y2v1nf65"
                },
                "var(--_1vqcj1i2i)": {
                    defaultClass: "_1y2v1nf66"
                },
                "var(--_1vqcj1i2j)": {
                    defaultClass: "_1y2v1nf67"
                },
                "var(--_1vqcj1i2k)": {
                    defaultClass: "_1y2v1nf68"
                },
                "var(--_1vqcj1i2l)": {
                    defaultClass: "_1y2v1nf69"
                },
                "var(--_1vqcj1i2m)": {
                    defaultClass: "_1y2v1nf6a"
                },
                "var(--_1vqcj1i2n)": {
                    defaultClass: "_1y2v1nf6b"
                },
                "var(--_1vqcj1i2o)": {
                    defaultClass: "_1y2v1nf6c"
                },
                "var(--_1vqcj1i2p)": {
                    defaultClass: "_1y2v1nf6d"
                },
                "var(--_1vqcj1i2q)": {
                    defaultClass: "_1y2v1nf6e"
                },
                "var(--_1vqcj1i2r)": {
                    defaultClass: "_1y2v1nf6f"
                },
                "var(--_1vqcj1i2s)": {
                    defaultClass: "_1y2v1nf6g"
                },
                "var(--_1vqcj1i2t)": {
                    defaultClass: "_1y2v1nf6h"
                },
                "var(--_1vqcj1i2u)": {
                    defaultClass: "_1y2v1nf6i"
                },
                "var(--_1vqcj1i2v)": {
                    defaultClass: "_1y2v1nf6j"
                },
                "var(--_1vqcj1i2w)": {
                    defaultClass: "_1y2v1nf6k"
                },
                "var(--_1vqcj1i2x)": {
                    defaultClass: "_1y2v1nf6l"
                },
                "var(--_1vqcj1i2y)": {
                    defaultClass: "_1y2v1nf6m"
                },
                "var(--_1vqcj1i2z)": {
                    defaultClass: "_1y2v1nf6n"
                },
                "var(--_1vqcj1i30)": {
                    defaultClass: "_1y2v1nf6o"
                },
                "var(--_1vqcj1i31)": {
                    defaultClass: "_1y2v1nf6p"
                },
                "var(--_1vqcj1i32)": {
                    defaultClass: "_1y2v1nf6q"
                },
                "var(--_1vqcj1i33)": {
                    defaultClass: "_1y2v1nf6r"
                },
                "var(--_1vqcj1i34)": {
                    defaultClass: "_1y2v1nf6s"
                },
                "var(--_1vqcj1i35)": {
                    defaultClass: "_1y2v1nf6t"
                },
                "var(--_1vqcj1i36)": {
                    defaultClass: "_1y2v1nf6u"
                },
                "var(--_1vqcj1i37)": {
                    defaultClass: "_1y2v1nf6v"
                },
                "var(--_1vqcj1i38)": {
                    defaultClass: "_1y2v1nf6w"
                },
                "var(--_1vqcj1i39)": {
                    defaultClass: "_1y2v1nf6x"
                },
                "var(--_1vqcj1i3a)": {
                    defaultClass: "_1y2v1nf6y"
                },
                "var(--_1vqcj1i3b)": {
                    defaultClass: "_1y2v1nf6z"
                },
                "var(--_1vqcj1i3c)": {
                    defaultClass: "_1y2v1nf70"
                },
                "var(--_1vqcj1i3d)": {
                    defaultClass: "_1y2v1nf71"
                },
                "var(--_1vqcj1i3e)": {
                    defaultClass: "_1y2v1nf72"
                },
                "var(--_1vqcj1i3f)": {
                    defaultClass: "_1y2v1nf73"
                },
                "var(--_1vqcj1i3g)": {
                    defaultClass: "_1y2v1nf74"
                },
                "var(--_1vqcj1i3h)": {
                    defaultClass: "_1y2v1nf75"
                },
                "var(--_1vqcj1i3i)": {
                    defaultClass: "_1y2v1nf76"
                },
                "var(--_1vqcj1i3j)": {
                    defaultClass: "_1y2v1nf77"
                },
                "var(--_1vqcj1i3k)": {
                    defaultClass: "_1y2v1nf78"
                },
                "var(--_1vqcj1i3l)": {
                    defaultClass: "_1y2v1nf79"
                },
                transparent: {
                    defaultClass: "_1y2v1nf7c"
                },
                inherit: {
                    defaultClass: "_1y2v1nf7b"
                }
            }
        }
    }
});
export { l as sprinkles };
